import Vue from 'vue'
import Router from 'vue-router'
import { addRoutePrefix } from '@/utils/microWeb'

const routes = [
  {
    name: 'Home',
    path: '/',
    component: () => import(/* webpackChunkName: "home" */ './views/HomeView.vue')
  },
  {
    name: 'Daily',
    path: '/DailySchedule',
    component: () => import(/* webpackChunkName: "home" */ './views/dailySchedule.vue')
  }
]

routes.forEach(route => {
  route.path = addRoutePrefix(route.path)
})

Vue.use(Router)

let router = new Router({
  routes
})

router.beforeEach((to, from, next) => {
  console.log('这特么', to)
  if (!to.path.startsWith('/app/work-plat')) {
    next({
      path: addRoutePrefix(to.path)
    })
  } else {
    next()
  }
})

export default router
